export * from './loading.component';